import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@patternfly/react-core';
import { PlusIcon } from '@patternfly/react-icons';
import { useContext, useEffect, useState } from 'react';
import { useFieldValue } from '../../hooks/field-value';
import { SchemaContext, SchemaProvider } from '../../providers/SchemaProvider';
import { getHexaDecimalRandomId, getItemFromSchema, isDefined } from '../../utils';
import { AutoField } from '../AutoField';
import { ArrayFieldWrapper } from './ArrayFieldWrapper';
export const ArrayField = ({ propName }) => {
    var _a, _b;
    const { schema, definitions } = useContext(SchemaContext);
    const { value, onChange, disabled } = useFieldValue(propName);
    const [itemsHash, setItemsHash] = useState([]);
    const label = (_b = (_a = schema.title) !== null && _a !== void 0 ? _a : propName.split('.').pop()) !== null && _b !== void 0 ? _b : propName;
    const itemsSchema = Array.isArray(schema.items) ? schema.items[0] : schema.items;
    if (!isDefined(itemsSchema)) {
        throw new Error(`ArrayField: items schema is not defined for ${propName}`);
    }
    const onAdd = () => {
        const localValue = value !== null && value !== void 0 ? value : [];
        const newItem = getItemFromSchema(itemsSchema, definitions);
        onChange([newItem, ...localValue]);
    };
    const getRemoveFn = (index) => () => {
        if (!Array.isArray(value))
            return;
        const newValue = [...value];
        newValue.splice(index, 1);
        onChange(newValue);
    };
    useEffect(() => {
        if (!Array.isArray(value))
            return;
        setItemsHash(value.map(() => getHexaDecimalRandomId('array-item')));
    }, [value]);
    return (_jsx(ArrayFieldWrapper, { propName: propName, type: "array", title: label, description: schema.description, defaultValue: schema.default, actions: _jsx(Button, { variant: "plain", "data-testid": `${propName}__add`, "aria-label": "Add new item", title: "Add new item", onClick: onAdd, icon: _jsx(PlusIcon, {}), isDisabled: disabled }), children: itemsHash.map((hash, index) => {
            const onRemove = getRemoveFn(index);
            return (_jsx(SchemaProvider, { schema: itemsSchema, children: _jsx(AutoField, { propName: `${propName}.${index}`, onRemove: onRemove }) }, hash));
        }) }));
};
//# sourceMappingURL=ArrayField.js.map